import { OAuthService } from 'angular-oauth2-oidc';
import {
  ConfigStateService,
  CurrentUserDto,
  EnvironmentService,
  SubscriptionService,
} from '@abp/ng.core';
import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { Observable, Subscriber, tap } from 'rxjs';
import { Confirmation, ConfirmationService } from '@abp/ng.theme.shared';

@Injectable({
  providedIn: 'root',
})
export class FeatureHubService {
  private _hubConnection: signalR.HubConnection;
  private _myUserId: string;
  private currentUser$: Observable<CurrentUserDto> = this.configState.getOne$('currentUser');

  constructor(
    environment: EnvironmentService,
    private _authService: OAuthService,
    private configState: ConfigStateService,
    private confirmationService: ConfirmationService,
  ) {
    this._hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(environment.getApiUrl('default') + '/signalr-hubs/feature', {
        accessTokenFactory: () => this._authService.getAccessToken(),
      })
      .withAutomaticReconnect()
      .build();
  }

  endConnection(): void {
    if (
      this._hubConnection.state != signalR.HubConnectionState.Disconnected &&
      this._hubConnection.state != signalR.HubConnectionState.Disconnecting
    ) {
      this._hubConnection.stop();
    }
  }

  startConnection(): Observable<void> {
    return new Observable<void>(observer => {
      if (this._authService.getAccessToken()) {
        this.currentUser$.subscribe(response => {
          if (response) {
            this._myUserId = response.id;
            this.startHubConnection(observer);
          }
        });
      } else {
        observer.complete();
      }
    });
  }

  private startHubConnection(observer: Subscriber<void>) {
    this._hubConnection
      .start()
      .then(() => {
        this._hubConnection.invoke('SubscribeAsync');
        observer.next();
        observer.complete();
      })
      .catch(error => {
        observer.error(error);
      });
  }

  receiveRefreshAll() {
    return new Observable<void>(observer => {
      this._hubConnection.on('RefreshAllAsync', () => {
        observer.next();
      });
    }).pipe(
      tap(() => {
        this.confirmationService
          .warn('Core::FeatureChanged', 'Core::AreYouSureToReload', {
            cancelText: 'Core::RefreshLater',
            yesText: 'Core::RefreshNow',
          })
          .subscribe(status => {
            if (status == Confirmation.Status.confirm) {
              window.location.reload();
            }
          });
      }),
    );
  }
}
